<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <h1>Távoli nyitás</h1>

          <div class="row">
            <div class="col-xs-2">
              <comboboxV2 @input="getElements" id="element_type_id" label="Típus" name="element_type_id" v-model="element_type_id" :options="element_types"/>
            </div>
          </div>

          <TabulatorTable v-if="elements.length > 0" v-model="elements" :options="tabulator_opts" />

        </div>
      </div>
    </div>
    <cameraViewPopup :opening="opening" :permanentOpening="permanentOpening" :normalOperationDatetime="normalOperationDatetime" :normalOperationNow="normalOperationNow" @close="barrier_id = false;" :barrier_id="barrier_id" v-if="barrier_id != false"/>
    <normalModePopup @save="normal_mode_popup_element_id = false; getElements();" @close="normal_mode_popup_element_id = false;" :normal_mode_popup_element_id="normal_mode_popup_element_id" v-if="normal_mode_popup_element_id != false"/>

    <HTMLFooter></HTMLFooter>
    <ProgressInfo :show="is_save"/>
  </div>
</template>
<script>
import Vue from 'vue';
import cameraViewPopup from './remote_open/camera_view_popup.vue';
import normalModePopup from './remote_open/normal_mode_popup.vue';

export default {
  components: {
    cameraViewPopup,
    normalModePopup
  },

  data: function() {
    var _this = this;

    return {
      is_save: false,
      element_types: [],
      element_type_id: 0,
      elements: [],
      barrier_id: false,
      normal_mode_popup_element_id: false,
      tabulator_opts: {
        initialSort: [{column:"label", dir:"desc"}],
        columns: [
          {title: "Megnevezés", field: "label", headerFilter: 'input', sorter: "string"},
          /*{title: "Állapot", field: "open", headerFilter: 'select', headerFilterParams: {'1': 'Nyitva', '0': 'Zárva'}, sorter: "string", formatter:
            function(cell, formatterParams, onRendered) {
              var txt = cell.getRow().getData().open == 1 ? 'Nyitva' : 'Zárva';

              if (parseInt(cell.getRow().getData().permanent_open_bool) == 1 && cell.getRow().getData().back_to_normal_datetime != null) {
                txt = txt + '<br>('+moment(cell.getRow().getData().back_to_normal_datetime).format('YYYY.MM.DD., HH:mm')+')';
              }

              return txt;
            }
          }*/,
          {headerSort: false, width: '200', formatter:
            function(cell, formatterParams, onRendered) {
              var s = '<div style="display:flex; flex-direction:column;">';

              if (cell.getRow().getData().permanent_open_bool == 0) {
                s = s + '<button style="margin-bottom:5px" onclick="opening('+cell.getRow().getData().element_id+', \''+cell.getRow().getData().label+'\')" class="button small orange with-icon" title="Kinyitás"><i class="fa fa-lock-open"></i>Kinyitás</button>';

                //Hack NCIOM miatt
                if (!cell.getRow().getData().nciom_control_seq_id)
                  s = s + '<button style="margin-bottom:5px" onclick="permanentOpening('+cell.getRow().getData().element_id+', \''+cell.getRow().getData().open_warning+'\', \''+cell.getRow().getData().label+'\')" class="button small orange with-icon" title="Tartós nyitás"><i class="fa fa-lock-open"></i>Tartós nyitás</button>';
              }

              if (parseInt(cell.getRow().getData().permanent_open_bool) == 1) {
                s = s + '<button style="margin-bottom:5px" onclick="normalOperationDatetime('+cell.getRow().getData().element_id+')" class="button small orange with-icon" title="Normál üzem időpont"><i class="fa fa-lock"></i>Normál üzem időpont</button>';
                s = s + '<button style="margin-bottom:5px" onclick="normalOperationNow('+cell.getRow().getData().element_id+', \''+cell.getRow().getData().label+'\')" class="button small orange with-icon" title="Normál üzem azonnal"><i class="fa fa-lock"></i>Normál üzem azonnal</button>';
              }

              if (_this.element_type_id == '13' && cell.getRow().getData().camera_video_stream)
                s = s + '<button style="margin-bottom:5px" onclick="setBarrierID('+cell.getRow().getData().element_id+')" class="button small orange with-icon" title="Kamerakép"><i class="fa fa-eye"></i>Kamerakép</button>';

              s = s + '</div>';

              return s;

            }, align: "center"
          }
        ]
      }
    }
  },

  created: function() {
    window.setBarrierID = this.setBarrierID;
    window.opening = this.opening;
    window.permanentOpening = this.permanentOpening;
    window.normalOperationDatetime = this.normalOperationDatetime;
    window.normalOperationNow = this.normalOperationNow;
  },

  mounted: function() {
    var _this = this;

    this.$root.checkRootUserHasSet(function() {
      _this.$root.ajax('remote_open/init/' + _this.$root.user.apikey, {
        method: 'GET',
        success: function(response) {
          _this.element_types = response.element_types;
          _this.element_type_id = response.element_types[0].value,
          _this.getElements();
        }
      });
    });
  },

  methods: {
    setBarrierID: function(barrier_id) {
      this.barrier_id = barrier_id;
    },

    opening: function(element_id, title, cb) {
      var _this = this;

      swal({
        title: 'Nyitja ' + title + '?',
        text: 'Nyitás után automatikusan visszazáródik.',
        icon: 'warning',
        buttons:
        {
          confirm: {
            text: "Igen",
            value: true,
            closeModal: true
          },
          cancel: {
            text: "Nem",
            value: false,
            visible: true,
            closeModal: true
          }
        }
      }).then(function (result) {
        if (result) {
          _this.$root.checkRootUserHasSet(function() {
            _this.$root.ajax('remote_open/open/' + element_id + '/' + _this.$root.user.apikey, {
              method: 'GET',
              success: function(response) {
                _this.getElements();

                if (cb != undefined)
                  cb();
              }
            });
          });
        }
      });
    },

    permanentOpening: function(element_id, open_warning, title, cb) {
      var _this = this;

      swal({
        title: 'Tartósan nyitja ' + title + '?',
        text: open_warning == '1' ? 'FIGYELEM! Ebben az ajtóban olyan zár található, melynek hosszan nyitva tartása annak meghibásodását okozhatja. Ennek az opciónak a használata itt nem javasolt, biztosan folytatja?' : 'Nyitás után tartósan nyitva marad.',
        icon: 'warning',
        buttons:
        {
          confirm: {
            text: "Igen",
            value: true,
            closeModal: true
          },
          cancel: {
            text: "Nem",
            value: false,
            visible: true,
            closeModal: true
          }
        }
      }).then(function (result) {
        if (result) {
          _this.$root.checkRootUserHasSet(function() {
            _this.$root.ajax('remote_open/permanent_open/' + element_id + '/' + _this.$root.user.apikey, {
              method: 'GET',
              success: function(response) {
                _this.getElements();

                if (cb != undefined)
                  cb();
              }
            });
          });
        }
      });

    },

    normalOperationDatetime: function(element_id) {
      this.normal_mode_popup_element_id = element_id;
    },

    normalOperationNow: function(element_id, title, cb) {
      var _this = this;

      swal({
        title: 'Normál üzemmódra vált ' + title + '?',
        icon: 'warning',
        buttons:
        {
          confirm: {
            text: "Igen",
            value: true,
            closeModal: true
          },
          cancel: {
            text: "Nem",
            value: false,
            visible: true,
            closeModal: true
          }
        }
      }).then(function (result) {
        if (result) {
          _this.$root.checkRootUserHasSet(function() {
            _this.$root.ajax('remote_open/to_normal_mode/' + _this.$root.user.apikey, {
              method: 'POST',
              data: {
                element_id: element_id,
                now: 1
              },
              success: function(response) {
                _this.getElements();

                if (cb != undefined)
                  cb();
              }
            });
          });
        }
      });
    },

    getElements: function() {
      var _this = this;

      this.element_id = 0;
      this.elements = [];

      if (this.element_type_id != 0) {
        this.$root.checkRootUserHasSet(function() {
          _this.$root.ajax('remote_open/elements/' + _this.element_type_id + '/' + _this.$root.user.apikey, {
            method: 'GET',
            success: function(response) {
              if (_this.tabulator_opts.columns[0].field == 'building')
                _this.tabulator_opts.columns.shift();

              if (response.elements.length > 0 && response.elements[0].building != undefined) {
                var headerFilterParams = {};
                response.elements.map(function(element) {
                  headerFilterParams[element.building] = element.building;
                });
                _this.tabulator_opts.columns.unshift({title: "Épület", field: "building", headerFilter: 'select', headerFilterParams: headerFilterParams, sorter: "string"});
              }
              _this.elements = response.elements;
            }
          });
        });
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// remote_open.vue?44f7d64d